import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
import { store } from "./store";

export const StoreProvider = ({ children }: { children: React.ReactNode }) => {
    return (
        <CookiesProvider>
            <Provider store={store}>{children}</Provider>
        </CookiesProvider>
    );
};
